// What a failed admin login tells the admin. A 429 — the backend's login
// limits, its temporary ban, or Cloudflare's edge rule — is "too many
// attempts", never "wrong details" (that only makes them try again), with the
// wait when the response says how long (Retry-After).

const WRONG_DETAILS = "خطأ في بيانات المستخدم!";

// Seconds until they can try again, from Retry-After (seconds or an HTTP
// date). null when it's missing or unreadable.
const retryAfterSeconds = (headers) => {
  const raw = headers?.["retry-after"];
  if (raw == null || raw === "") return null;
  const seconds = Number(raw);
  if (Number.isFinite(seconds)) return Math.max(0, Math.ceil(seconds));
  const at = Date.parse(raw);
  return Number.isNaN(at) ? null : Math.max(0, Math.ceil((at - Date.now()) / 1000));
};

// The wait, in grammatical Arabic: a moment / 45 seconds / two minutes /
// 5 minutes / 15 minutes.
const waitText = (seconds) => {
  if (seconds == null || seconds <= 10) return "بعد قليل";
  if (seconds <= 90) return `بعد ${seconds} ثانية`;
  const minutes = Math.ceil(seconds / 60);
  if (minutes === 2) return "بعد دقيقتين";
  if (minutes <= 10) return `بعد ${minutes} دقائق`;
  return `بعد ${minutes} دقيقة`;
};

export const loginErrorMessage = (error) => {
  const response = error?.response;
  if (!response) return "تعذر الاتصال بالخادم. تحقق من الاتصال وحاول مرة أخرى.";
  if (response.status === 429) {
    return `محاولات تسجيل دخول كثيرة. حاول مرة أخرى ${waitText(
      retryAfterSeconds(response.headers),
    )}.`;
  }
  if (response.status >= 500) return "حدث خطأ في الخادم. حاول مرة أخرى بعد قليل.";
  if (response.status === 400 || response.status === 401) return WRONG_DETAILS;
  return "تعذر تسجيل الدخول. حاول مرة أخرى.";
};
